// Copyright (c) Move Closer 2022.

import { ShippingMethodCode } from '../../../../contexts'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const shippingIcon: Record<string, string> = {
  [ShippingMethodCode.Flatrate]: require('./assets/images/dhl.svg'),
  [ShippingMethodCode.DHLKurier]: require('./assets/images/dhl.svg'),
  [ShippingMethodCode.DPDKurier]: require('./assets/images/dpd.svg'),
  [ShippingMethodCode.GlsKurier]: require('./assets/images/gls.svg'),
  [ShippingMethodCode.Free]: require('./assets/images/dhl.svg'),
  // [ShippingMethodCode.InpostKurier]: require('./assets/images/inpost.svg'),
  [ShippingMethodCode.OrlenPaczkaPobranie]: require('./assets/images/orlen.svg'),
  [ShippingMethodCode.OrlenPaczka]: require('./assets/images/orlen.svg'),
  [ShippingMethodCode.InPostLocker]: require('./assets/images/InpostLocker.svg'),
  [ShippingMethodCode.InPostCourier]: require('./assets/images/InpostCourier.svg'),
  [ShippingMethodCode.InPostLockerCod]: require('./assets/images/inpost.svg'),
  [ShippingMethodCode.DPD]: require('./assets/images/dpd.svg'),
  [ShippingMethodCode.DPDCod]: require('./assets/images/dpd.svg'),
  [ShippingMethodCode.AramexCreditsCardsDelivery]: require('./assets/images/aramex.png'),
  [ShippingMethodCode.AramexOverNightDocument]: require('./assets/images/aramex.png'),
  [ShippingMethodCode.AramexSameDayDocument]: require('./assets/images/aramex.png'),
  [ShippingMethodCode.AramexOverNightParcel]: require('./assets/images/aramex.png')
  // [ShippingMethodCode.UPS]: ''
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const supportedShippingMethods: string[] = [
  ShippingMethodCode.DHLKurier,
  ShippingMethodCode.InPostCourier,
  ShippingMethodCode.InPostLocker,
  ShippingMethodCode.Free,
  ShippingMethodCode.DPDKurier
]

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export function isFreeShipmentThresholdReached (shipments: string[]): boolean {
  return shipments.includes(ShippingMethodCode.Free)
}
